import { B2BOrdersApi } from '@/gen/ecom/apis'
import { ecomConfiguration } from './apiConfigs'

export const b2bOrdersClient = new B2BOrdersApi(ecomConfiguration)
